<script lang="ts">
    import Tooltip from "./Tooltip.svelte"
    import HelpCircleOutline from "svelte-material-icons/HelpCircleOutline.svelte"

    let active = false

    export let name
    export let type: "text" | "email" | "password" | "tel" | "number" = "text"
    export let placeholder: string = ""
    export let tooltip: string | undefined = undefined
    export let label: string | undefined = undefined
    export let value: string | number = ""
    export let disabled: boolean = false
    export let required: boolean = false
    export let maxlength: number | undefined = undefined
    export let min: number | undefined = undefined
    export let max: number | undefined = undefined
    export let step: number | undefined = undefined
    export let pattern: string | undefined = undefined
    export let style: string | undefined = undefined
    export let readonly: boolean = false
    export let decimals: number | undefined = undefined
    export let fullWidth: boolean = false
    export let opacity: boolean = false
    let className: string = ""
    export { className as class }
</script>

<div class:full-width="{fullWidth}" class:opacity="{opacity}" class="inputholder" class:haslabel="{!!label}">
    {#if label}<label for="{name}">{label}</label>{/if}
    <input
        disabled="{disabled}"
        type="{type}"
        name="{name}"
        placeholder="{placeholder}"
        required="{required}"
        maxlength="{maxlength}"
        min="{min}"
        max="{max}"
        step="{step}"
        pattern="{pattern}"
        value="{value}"
        on:input="{(e) => {
            // @ts-ignore
            value = type == 'number' ? Number(e.target.value) : e.target.value
            // if type is number and decimals is set, round to that number of decimals
            if (type == 'number' && typeof decimals !== 'undefined') {
                // @ts-ignore
                value = Math.round(value * 10 ** decimals) / 10 ** decimals
            }
        }}"
        on:change
        style="{style}"
        readonly="{readonly}"
        class="{className}"
    />
    {#if tooltip}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
            class="tooltip_icon"
            on:click="{() => {
                active = !active
            }}"
        >
            <HelpCircleOutline />
            {#if active}
                <Tooltip style="bottom" text="{tooltip}" />
            {/if}
        </div>
    {/if}
</div>

<style lang="less">
    .opacity {
        opacity: 0.5;
        input {
            background-color: white;
        }
    }
    .full-width {
        width: 100%;
    }
    .inputholder :global {
        position: relative;

        label {
            position: absolute;
            top: 4px;
            left: 20px;
            font-size: 0.7rem;
        }
        .tooltip_icon {
            cursor: pointer;
            position: absolute;
            right: 0;
            top: 10px;
            bottom: 10px;
            border-left: solid 1px var(--border-color-2);
            color: inherit;
            width: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s;
            &:hover {
                color: inherit;
            }
        }
    }
    .haslabel {
        input {
            height: 55px;
            padding-top: 15px;
        }
    }
</style>
